// Unit conversion constants
export const MM_PER_INCH = 25.4;
export const GRAMS_PER_OZ = 28.3495;

// Cookie helper functions
export const setCookie = (name, value, days = 365) => {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

// Shared calculation utilities
export const round = (number, decimals = 2) => {
  if (isNaN(number) || number === null) {
    return 0; // Or handle as appropriate, return 0 for calculations
  }
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
};

export const formatNumber = (number) => {
  const rounded = round(number);
  if (rounded >= 1000) {
    return rounded.toLocaleString('en-US');
  }
  return rounded.toString();
};

export const convertLength = (value, toMetric) => {
  const num = parseFloat(value);
  if (isNaN(num) || value === '') return '';
  return round(toMetric ? num * MM_PER_INCH : num / MM_PER_INCH);
};

export const convertWeight = (value, toMetric) => {
  console.log(`convertWeight called: value=${value}, toMetric=${toMetric}`);
  const num = parseFloat(value);
  if (isNaN(num) || value === '') {
    console.log('convertWeight: invalid number, returning empty string');
    return '';
  }
  // Remove the round() call here to return the precise value
  const result = toMetric ? num * GRAMS_PER_OZ : num / GRAMS_PER_OZ;
  console.log(`convertWeight result (raw): ${result}, returning: ${result}`);
  return result;
};

// Function to calculate the area based on shape type and dimensions
export const calculateArea = (shapeType, width, length, diameter) => {
  const numWidth = parseFloat(width) || 0;
  const numLength = parseFloat(length) || 0;
  const numDiameter = parseFloat(diameter) || 0;

  // Ensure dimensions are non-negative
  if (numWidth < 0 || numLength < 0 || numDiameter < 0) {
    console.error("calculateArea: Dimensions cannot be negative.");
    return 0; // Or NaN, depending on desired handling
  }

  switch (shapeType) {
    case 'rectangle':
      return numWidth * numLength;
    case 'square':
      // For square, width and length should ideally be the same. Use width.
      return numWidth * numWidth;
    case 'circle':
      if (numDiameter <= 0) return 0;
      const radius = numDiameter / 2;
      return Math.PI * radius * radius;
    case 'triangle':
      // Assuming width is base and length is height for triangle
      return 0.5 * numWidth * numLength;
    case 'custom':
       // If 'custom', assume width is provided as the area directly
       // This matches the behavior in ReferenceSection where custom area is input into width
       // We might need a dedicated 'area' field later if this becomes confusing
      return numWidth;
    default:
      console.warn(`calculateArea: Unknown shape type "${shapeType}". Returning 0.`);
      return 0; // Default case if shape type is missing or unrecognized
  }
};

export const validateAndFormatValue = (value, isCount = false) => {
  const numValue = parseFloat(value);
  if (isNaN(numValue)) return 0;

  const positiveValue = Math.abs(numValue);
  
  if (isCount) {
    return Math.max(1, Math.ceil(positiveValue));
  }
  
  return Math.round(positiveValue * 100) / 100;
};
